// extracted by mini-css-extract-plugin
export default {"General":"GeneralPortfolio_General__BIdTI","GeneralBigImage":"GeneralPortfolio_GeneralBigImage__nYMrq"};